import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareSecurityClassicRoute: InvariantJiraRoute = {
	name: 'software-security-classic',
	path: '/jira/software/c/projects/:projectKey/security',
};
